/**
 * Copy da bolha de mensagem que não tem chave em `constants/TextChat.js`
 * (arquivo de outro dono — o destino final destas chaves é lá).
 */
export const COPY_CHAT_MESSAGE = Object.freeze({
  erroCopiar: 'Não foi possível copiar. Tente novamente.',
  tituloErroDoTurno: 'Não foi possível concluir',
  avisoTruncada:
    'Esta resposta pode ter sido interrompida pelo limite de tamanho. Peça para continuar.',
})
